import { FunctionComponent, useContext, useCallback } from 'react';
import {
  PageHeader,
  Form,
  Group,
  FormImage,
  ResponsivePadding,
} from '../../components';
import { AccountFields } from './AccountFields';
import { AuthStore, updateAuthUser, BrandStore } from '../../context';
import {
  mapUserToInitialFormValues,
  mapFormValuesToPayload,
  validateFormValues,
} from './AccountFields.util';
import { AccountFieldsValues } from './AccountFields.types';
import { coreapi } from '../../api';
import { history } from '../../history';
import { useToaster } from '../../hooks';
import { PrimaryButton } from '@stax-core/truffle-components';
import signupPasswordSvg from '../../assets/img/signup_password.svg';

export const AccountPage: FunctionComponent = () => {
  const {
    dispatch,
    state: { auth },
  } = useContext(AuthStore);
  const {
    state: { brand },
  } = useContext(BrandStore);
  const { toaster, toast } = useToaster();
  const authToken = auth && auth.token;
  const { regPasswordHeader, regPasswordBody } = brand || {};
  const sendWelcomeEmail = brand?.sendWelcomeEmail;

  const onSubmit = useCallback(
    async (formValues: AccountFieldsValues) => {
      const payload = mapFormValuesToPayload(formValues);

      try {
        const user = await coreapi.put(authToken!, '/self', {
          ...payload,
          //  only set flag if merchant's brand have the flag setWelcomeEmail active in AirTable
          // flag is used to conditionally sent user a welcome email
          send_welcome_email: sendWelcomeEmail,
          mfa_enabled: brand?.displayName === 'Stax' ? true : undefined,
        });
        dispatch(updateAuthUser(user));
        history.push('/application/business');
      } catch (error) {
        toaster(
          toast.error(error, 'There was a problem setting your password.'),
        );
      }
    },
    [authToken, dispatch, toaster, toast, sendWelcomeEmail, brand],
  );

  return (
    <>
      <PageHeader
        header={regPasswordHeader}
        id="account-page-header"
        data-testid="account-page-header"
        description={<p>{regPasswordBody}</p>}
      />
      <ResponsivePadding>
        <Form
          initialValues={mapUserToInitialFormValues(auth && auth.user)}
          validate={validateFormValues}
          onSubmit={onSubmit}
        >
          {formProps => (
            <AccountFields mode="edit" {...formProps}>
              <Group justify="end">
                <PrimaryButton
                  type="submit"
                  style={{ width: '100%' }}
                  id="account-continue-button"
                  data-testid="account-continue-button"
                  trackingId="account-continue-button"
                  disabled={formProps.submitting}
                >
                  Save &amp; Continue
                </PrimaryButton>
              </Group>
              <FormImage
                className="-mobile-hide"
                src={signupPasswordSvg}
                height="30rem"
              />
            </AccountFields>
          )}
        </Form>
      </ResponsivePadding>
    </>
  );
};
